import {
    faBuildingColumns as SavingBank,
    faSackDollar as MoneyBag,
    faFileInvoiceDollar as Document,
    faMoneyBill as AccountingBills,
    faCreditCard as CreditCard,
    faMoneyCheckDollarPen as CheckPayment,
    // TODO: FIND APPROPRIATE ICON FOR CHARGEBACK
    faXmarkToSlot as CreditCardRemove
} from '@fortawesome/pro-light-svg-icons';
import { lowercase, sentencecase, uncamelcase, unsnakecase } from './string';

// The backend's own name for how money moved, rendered rather than mapped.
// Mapping payment_source by hand here produced "ACH" for every bank rail, which
// is wrong for four of the five currencies deposit links support: the same rail
// covers SEPA, BACS, BECS and PAD. display_type is the maintained string and
// already distinguishes a bank debit (money pulled) from a bank transfer (money
// the customer sent).
//
// Normalised through all three helpers because the value arrives in more than
// one shape across endpoints - "bank_debit" and "BankDebit" both reach
// "Bank debit", and sentencecase restores known acronyms so "ach" is not left
// lowercased.
export const getPaymentTypeLabel = (displayType) =>
    sentencecase(unsnakecase(uncamelcase(displayType || '')));

// Very advanced algorithm to determine what headline + icon to show
export const getTxnTypeDisplayDetails = (txn) => {
    switch (lowercase(txn?.type)) {
    case 'creditnote':
        return { name: 'Credit Note', icon: Document};
    case 'debitnote':
        return { name: 'Debit Note', icon: Document};
    case 'chargeback':
        return { name: 'Chargeback', icon: CreditCardRemove};
    case 'bank_transfer':
    case 'bank transfer':
    case 'externalpayment':
    case 'payment':
        let type = lowercase(txn?.payment_source || '')
        let icon = SavingBank;
        let name = 'ACH';
        if (type?.includes('ach')) {
            name = 'ACH';
        } else if (type === 'cash') {
            name = 'Cash';
            icon = AccountingBills;
        } else if (type === 'card') {
            name = 'Card';
            icon = CreditCard;
        } else if (type === 'check') {
            name = 'Check';
            icon = CheckPayment;
        } else if (type === 'wire') {
            name = 'Wire';
        } else if (type === 'bank_transfer') {
            name = 'Bank transfer';
        }
        // The backend's own name wins when it sends one. Mapping payment_source
        // by hand cannot tell a debit we pulled from a transfer the customer
        // sent, and calls every bank rail "ACH", which is wrong for four of the
        // five currencies we support: the same rail carries SEPA, BACS, BECS and
        // PAD. The icon still comes from the source, since display_type has none.
        // The mapping stays as the fallback for payloads that omit display_type,
        // such as the pending transactions endpoint.
        return { name: txn?.display_type ? getPaymentTypeLabel(txn.display_type) : name, icon };
    default:
        return { name: uncamelcase(txn?.display_type), icon: MoneyBag };
    }
}

//TODO: refactor and combined with above
export const getSearchTxnTypeDisplayDetails = (txn) => {
    switch (lowercase(txn?.type)) {
    case 'creditnote':
        return { name: 'Credit note', icon: Document};
    case 'debitnote':
        return { name: 'Debit note', icon: Document};
    case 'chargeback':
        return { name: 'Chargeback', icon: CreditCardRemove};
    case 'stripesettlement':
        return { name: 'Bank transfer', icon: SavingBank };
    case 'bank_transfer':
    case 'bank transfer':
    case 'externalpayment':
    case 'payment':
        let type = lowercase(txn?.payment_source || '')
        if (type?.includes('ach'))
            return { name: 'Bank transfer', icon: SavingBank };
        else if (type === 'cash')
            return { name: 'Cash payment', icon: AccountingBills };
        else if (type === 'card')
            return { name: 'Card payment', icon: CreditCard };
        else if (type === 'check')
            return { name: 'Check payment', icon: CheckPayment };
        else if (type === 'wire')
            return { name: 'Wire transfer', icon: SavingBank };
        else if (type === 'bank_transfer')
            return { name: 'Bank transfer', icon: SavingBank };
        else
            return { name: 'Bank transfer', icon: SavingBank };
    default:
        return { name: uncamelcase(txn?.type), icon: MoneyBag };
    }
}
